import DefaultModal from '@/components/organisms/common/modal/DefaultModal';
import { ModalStaticFunctions } from 'antd/lib/modal/confirm';
import { Button, Form, FormItem, Input } from '@/components/atoms';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

export type ManageUserEditModalProps = {
  visible: boolean;
  onClose: () => void;
  modal?: Pick<ModalStaticFunctions, 'info' | 'confirm'>;
};

const ManageUserEditModal = ({ visible, onClose, modal }: ManageUserEditModalProps) => {
  const { user } = useSelector((state: RootState) => state.account);
  const [userForm] = Form.useForm();
  return (
    <DefaultModal modalVisible={visible} titleText="회원정보 변경" onCancel={onClose}>
      <Form
        layout="vertical"
        form={userForm}
        initialValues={{
          name: user.name,
          mobile: user.mobile,
        }}
      >
        <FormItem label="이름" name="name" rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem label="연락처" name="mobile" rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem>
          <Button type="dark" shape="round" htmlType="submit">
            확인
          </Button>
        </FormItem>
      </Form>
    </DefaultModal>
  );
};

export default ManageUserEditModal;
